import React, { FunctionComponent, useRef, useEffect } from "react";
import styles from "../../../Screens/AddProject/AddProject.module.css";
import { useState } from "react";
import Loading from "../../Loading/Loading";
import TextInput from "../../TextInput/TextInput";
import Dropdown from "../../DropDown/Dropdown";
import { useLocation } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import { connect, useDispatch } from "react-redux";
import { showSnackbarAction } from "../../../Redux/actions";
import { contactResources } from "../../../Services/contacts";
import { updateProjectMongo } from "../../../Services/projects";
import { themeColors } from "../../theme";
import Label from "../../Label";
import { alphabetValidatorProjectName, aphabetValidator } from "../../../Values/validatorsnew";
import { googleAnalytics, googleAnalyticsCTAClick } from "../../../Services/users";


const propertyStatus=["INTERMEDIATE","Launched","Not Launch"];
const RentpropertyStatus=["Available","Un-Available"];
type props = {
  history: any;
  user: any;
  theme: any;
  organizationData: any;
  authToken: any;
  constants: any;
  userPreference: any;
  organizationResources:any;
};
const ProjectEditModal: FunctionComponent<props> = ({ history, user, theme, organizationData,authToken,constants,userPreference,organizationResources }) => {
  const location: any = useLocation();
  const dispatcher = useDispatch();
  const [load, setLoad] = useState(false);
  const [propertyTypeSelected, setPropertyTypeSelected] = useState<any>({
    label:"",
    value:"",
  });
  const [projectStatusSelected, setProjectStatusSelected] = useState<any>({
    value:"Select",
    label:"Select"
});
  const [projectsList, setProjectsList] = useState<any[] | undefined>(
    undefined
  );
  const [businessVerticalList, setBusinessVerticalList] = useState<any[]>(
    []
  );
  const [businessVerticalSelected, setBusinessVerticalSelected] =
  useState<any>({
    label: "Select",
    value: "Select",
  });
  const [propertyTypes, setPropertyTypes] = useState<any[]>([]);
  const projectNameRef: any = useRef();
  const developerNameRef: any = useRef();
  const addressRef: any = useRef();
  const reraRef: any = useRef();
  const walkthroughRef: any = useRef();
  const unitRef: any = useRef();
  const priceRef:any = useRef();
  const ownerNameRef:any = useRef()
  const ownerContactRef:any = useRef()

  const [description, setDescription] = useState(location.state.detail.description?location.state.detail.description:"");
  const [propertyStageList, setPropertyStageList] = useState<string[]>([]);
  const [isGACalled, setIsGACalled] = useState<any>(false);
  const [propertyStageSelected, setPropertyStageSelected] = useState<any>({
    label: "",
    value: "",
  });
  // useEffect(() => {
  //   let data = ["Ready to move in", "Under Construction"];
  //   setPropertyStages(data);
  // }, []);

  const constant = async () => {
    const propertyStageValues:any = Object.values(constants.propertyStage);
    const propertyTypeValues = Object.values(constants.propertyType);
   setPropertyStageList(propertyStageValues);
   setPropertyTypes(propertyTypeValues)
  };

  useEffect(() => {
    if (constants && constants.propertyStage) {
      constant();
    }
  }, [constants]);


  useEffect(()=>{
    setPropertyTypeSelected({
      label: location.state.detail.property_type,
      value: location.state.detail.property_type,
    })
    setProjectStatusSelected({
      label: location.state.detail.project_status,
      value: location.state.detail.project_status,
    })
    setPropertyStageSelected(
      {
        label: location.state.detail.property_stage,
        value: location.state.detail.property_stage,
      }
    )
    setBusinessVerticalSelected(
      {
        label: location.state.detail.business_vertical,
        value: location.state.detail.business_vertical,
      }
    )
  },[propertyTypes,
    propertyStatus,
    // propertyStages
  ]);

  useEffect(()=>{
      if(organizationResources){
        organizationResources.forEach((val:any)=>{
          if(val.resource_type==="businessVertical"){
            let loc:any=[]
            val["businessVertical"].forEach((item:any)=>{
                  loc.push(item.businessVertical)
            })
            setBusinessVerticalList(loc);
          }
        })
      }
  },[organizationResources])

  // useEffect(() => {
  //   const unsub = contactResources(
  //     user.organization_id,
  //     () => {},
  //     () => {},
  //     () => {},
  //     (data) => setBusinessVerticalList(data),
  //     organizationData
  //   );

  //   return () => {
  //     unsub();
  //   };
  //   // eslint-disable-next-line
  // }, []);

  const handleCheck = () => {
    if(!organizationData.business_domain || organizationData.business_domain== "Real Estate"){
    const words = description.split(/\s+/);
      if (projectNameRef.current.value === "") {
        projectNameRef.current.value = location.state.detail.project_name;
      }
      if (developerNameRef.current.value === "") {
        // developerNameRef.current.value = location.state.detail.developer_name;
        dispatcher(showSnackbarAction("Please Enter Developer Name", "error"));
        return false;
      }
      if (addressRef.current.value === "") {
        // addressRef.current.value = location.state.detail.address;
        dispatcher(showSnackbarAction("Please Enter Address", "error"));
        return false;
      }
      if (walkthroughRef.current.value === "") {
        // walkthroughRef.current.value = location.state.detail.walkthrough_link;
        dispatcher(showSnackbarAction("Please Enter Walkthrough Link", "error"));
        return false;
      }
      if (propertyTypeSelected.label === "Select") {
        propertyTypeSelected.label = location.state.detail.property_type;
      }
      if (projectStatusSelected.label === "Select") {
        projectStatusSelected.label = location.state.detail.project_status;
      }
      if (propertyStageSelected.label === "Select") {
        propertyStageSelected.label = location.state.detail.property_stage;
      }
      if(developerNameRef.current.value !== "" && alphabetValidatorProjectName(developerNameRef.current.value) === "Invalid Name"){
        dispatcher(showSnackbarAction("No special character allowed in developer name", "error"));
        return false;
    }
    if(projectNameRef.current.value !== "" && alphabetValidatorProjectName(projectNameRef.current.value) === "Invalid Name"){
      dispatcher(showSnackbarAction("No special character allowed in project name", "error"));
      return false;
  }
  if(description !== ""&& (words.length >= 300)){
    dispatcher(showSnackbarAction("Max 300 words allowed for the description", "error"));
    return false;
}
    }else{
      if (projectNameRef.current.value === "") {
        projectNameRef.current.value = location.state.detail.project_name;
      }
      if (addressRef.current.value === "") {
        // addressRef.current.value = location.state.detail.address;
        dispatcher(showSnackbarAction("Please Enter Address", "error"));
        return false;
      }
      if (businessVerticalSelected.label === "Select") {
        businessVerticalSelected.label = location.state.detail.business_vertical;
      }
      if(projectNameRef.current.value !== "" && alphabetValidatorProjectName(projectNameRef.current.value) === "Invalid Name"){
        dispatcher(showSnackbarAction("No special character allowed in project name", "error"));
        return false;
    }
    
    }

    return true;
  };
  const handleCheckRental = () => {
    if(!organizationData.business_domain || organizationData.business_domain== "Real Estate"){
    const words = description.split(/\s+/);
      if (unitRef.current.value === "") {
        dispatcher(showSnackbarAction("Please Enter Unit No.", "error"));
        return false;
      }
       else if (priceRef.current.value === "") {
        dispatcher(showSnackbarAction("Please Enter Price", "error"));
        return false;
      }else
      if (addressRef.current.value === "") {
        // addressRef.current.value = location.state.detail.address;
        dispatcher(showSnackbarAction("Please Enter Address", "error"));
        return false;
      }else if (projectStatusSelected.label === "Select") {
        projectStatusSelected.label = location.state.detail.project_status;
      }
      if(description !== ""&& (words.length >= 300)){
        dispatcher(showSnackbarAction("Max 300 words allowed for the description", "error"));
        return false;
  }
      else {
        return true;
      }
    }else
    {
      if (unitRef.current.value === "") {
        dispatcher(showSnackbarAction("Please Enter Unit No.", "error"));
        return false;
      }
       else if (priceRef.current.value === "") {
        dispatcher(showSnackbarAction("Please Enter Price", "error"));
        return false;
      }
      else {
        return true;
      }
    }
    };
  const edit = (e: any) => {
    e.preventDefault();
    let val
    googleAnalyticsCTAClick("Listing Update Button","Listing Screen",user)
    {(!location.state.detail.type || location.state.detail.type==="NEW PROJECT")? (val = handleCheck()):(val=handleCheckRental())}
    if (val) {
      setLoad(true);
      if(!organizationData.business_domain || organizationData.business_domain== "Real Estate"){
        updateProjectMongo(
          dispatcher,
          (data) => setLoad(data),
          "",
          authToken,
          user.uid,
          location.state.detail._id,
          history,
          projectNameRef?.current?.value.trim(),
          developerNameRef?.current?.value.trim(),
          addressRef?.current?.value,
          propertyTypeSelected?.label,
          projectStatusSelected?.label,
          propertyStageSelected?.label,
          reraRef?.current?.value,
          walkthroughRef?.current?.value,
          ownerNameRef?.current?.value,
          ownerContactRef?.current?.value,
          priceRef?.current?.value,
          unitRef?.current?.value,
          location.state.detail.type,
          description
        );
      }else{
        updateProjectMongo(
          dispatcher,
          (data) => setLoad(data),
          "",
          authToken,
          user.uid,
          location.state.detail._id,
          history,
          projectNameRef?.current?.value.trim(),
          developerNameRef?.current?.value.trim(),
          addressRef?.current?.value,
          propertyTypeSelected?.label,
          projectStatusSelected?.label,
          propertyStageSelected?.label,
          reraRef?.current?.value,
          walkthroughRef?.current?.value,
          ownerNameRef?.current?.value,
          ownerContactRef?.current?.value,
          priceRef?.current?.value,
          unitRef?.current?.value,
          location.state.detail.type,
          description
        );
      }
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent typing 'e', '.', and '-' keys if type is number
    if (e.key === "e" || e.key === "." || e.key === "-") {
      e.preventDefault();
    }
  };
  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Edit_Listings_Screen',user)
      }
    }
  },[user])
  return (
    <div className={styles.parent} style={containerStyles}>
      {load === true && <Loading />}
      <div
        // className={styles.headerView}
        className="d-flex flex-row w-100 px-4 pt-4"
      >
        <h5
        // className={styles.heading}
        > Edit {location.state.detail.type ? location.state.detail.type : "PROJECT"} Details</h5>
        <AiOutlineClose
          className={styles.closeIcon}
          size={25}
          onClick={() => history.replace("/projects")}
        />
      </div>
      <div
        // className={styles.child}
        className="w-100 d-flex flex-column gap-2 px-4"
      >
        <form className="card pt-1 pb-4 px-4 shadow rounded mt-2 pt-4" style={cardContainerStyles}>
          <div className={styles.box2}>
            {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
            <div className={styles.divide}>
              {(!location.state.detail.type || location.state.detail.type==="NEW PROJECT")?
                <Label label="Developer Name" required={true} />
                :
                <Label label="Developer Name" required={false} />}
              <div style={{ width: "150px" }}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={developerNameRef}
                  value={location.state.detail.developer_name}
                  validator={alphabetValidatorProjectName}
                ></TextInput>
              </div>
            </div>}
            <div className={styles.divide}>
              {(!location.state.detail.type || location.state.detail.type==="NEW PROJECT")?
              <Label label="Project Name" required={true} />
              :
              <Label label="Project Name" required={false} />}
              <div style={{ width: "150px" }}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={projectNameRef}
                  value={location.state.detail.project_name} 
                  validator={alphabetValidatorProjectName}
                  disabled={true}
                ></TextInput>
              </div>
            </div>
            {(organizationData.business_domain && organizationData.business_domain !== "Real Estate")&&(
                          <div className={styles.divide}>
                          <Label label="Business Vertical" required={true} />
                          <div style={{ width: "140px", marginRight: "5px" }}>
                            <Dropdown
                              option={businessVerticalList}
                              selectedValue={businessVerticalSelected}
                              setSelectedValue={(value) => {
                                setBusinessVerticalSelected(value);
                              }}
                            />
                            </div>
                        </div>
            )}
            <div className={styles.divide}>
              <Label label="Address" required={true} />
              <div style={{ width: "150px" }}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={addressRef}
                  // disabled={location.state.detail.project_status==="Not Launch"?false:true}
                  value={location.state.detail.address}
                />
              </div>
            </div>
          </div>
          {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
          <div className={styles.box2}>
            <div className={styles.divide}>
              {(!location.state.detail.type || location.state.detail.type==="NEW PROJECT")?
              <Label label="Property Type" required={true} />
              :
              <Label label="Property Type" required={false} />}
              <div style={{ width: "140px", marginRight: "5px" }}>
                <Dropdown
                  option={propertyTypes}
                  selectedValue={propertyTypeSelected}
                  setSelectedValue={(value) => setPropertyTypeSelected(value)}
                />
              </div>
            </div>
            {(!location.state.detail.type || location.state.detail.type==="NEW PROJECT")?
            <div className={styles.divide}>
              <Label label="Rera Link" required={false} />
              <div style={{ width: "150px" }}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={reraRef}
                  value={location.state.detail.rera_link}
                  // disabled={location.state.detail.project_status==="Not Launch" || location.state.detail.project_status==="INTERMEDIATE"?false:true}
                />
              </div>
            </div>:
            <div className={styles.divide}>
            <Label label="Owner Name" required={false} />
            <div style={{ width: "150px" }}>
              <TextInput
                title={""}
                style={{ backgroundColor: "#fff" }}
                ref={ownerNameRef}
                value={location.state.detail.owner_name}
              />
            </div>
          </div>}

            {(!location.state.detail.type || location.state.detail.type==="NEW PROJECT")?
            <div className={styles.divide}>
              <Label label="Walkthrough Link" required={true} />
              <div style={{ width: "150px" }}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={walkthroughRef}
                  value={location.state.detail.walkthrough_link}
                />
              </div>
            </div>:
            <div className={styles.divide}>
            <Label label="Owner Contact No." required={false} />
            <div style={{ width: "150px" }}>
              <TextInput
                type="number"
                title={""}
                style={{ backgroundColor: "#fff" }}
                ref={ownerContactRef}
                value={location.state.detail.owner_contact_no}
                minValue={'0'}
                onKeyDown={handleKeyDown}
              />
            </div>
          </div>}
          </div>}
          {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
          <div className={styles.box2}>
            <div className={styles.divide}>
              {(!location.state.detail.type || location.state.detail.type==="NEW PROJECT")?
              <Label label="Property Stage" required={true} />
              :
              <Label label="Property Stage" required={false} />}
              <div style={{ width: "140px", marginRight: "5px" }}>
                <Dropdown
                  option={propertyStageList}
                  selectedValue={propertyStageSelected}
                  setSelectedValue={(value) => setPropertyStageSelected(value)}
                />
              </div>
            </div>
            {(location.state.detail.type && location.state.detail.type!=="NEW PROJECT") &&
            <div className={styles.divide}>
            <Label label="Price" required={true} />
            <div style={{ width: "150px" }}>
              <TextInput
              type="number"
                title={''}
                style={{ backgroundColor: "#fff" }}
                ref={priceRef}
                value={location.state.detail.price}
                minValue={'0'}
                onKeyDown={handleKeyDown}
              />
            </div>
          </div>}
            <div className={styles.divide}>
              
            {location.state.detail.type==="NEW PROJECT"?<Label label="Project Status" required={true} />:<Label label="Availability Status" required={true} />}
              <div style={{ width: "140px", marginRight: "5px" }}>
                {(!location.state.detail.type || location.state.detail.type==="NEW PROJECT")?
                <Dropdown
                  option={propertyStatus}
                  selectedValue={projectStatusSelected}
                  setSelectedValue={(value) => setProjectStatusSelected(value)}
                />:
                <Dropdown
                  option={RentpropertyStatus}
                  selectedValue={projectStatusSelected}
                  setSelectedValue={(value) => setProjectStatusSelected(value)}
                />
                }
              </div>
            </div>
            { (!location.state.detail.type || location.state.detail.type==="NEW PROJECT" ) &&
              <div className={styles.divide}>
                <Label label="Unit No." required={false} />
                <div style={{ width: "150px" }}>
                  <TextInput
                    title={""}
                    style={{ backgroundColor: "#fff" }}
                    ref={unitRef}
                    value={location.state.detail.unit_no}
                  />
                </div>
              </div>
          }
          </div>}
          { (location.state.detail.type && location.state.detail.type!=="NEW PROJECT") &&
            <div className={styles.box2}>
              <div className={styles.divide}>
                <Label label="Unit No." required={true} />
                <div style={{ width: "150px" }}>
                  <TextInput
                    title={""}
                    style={{ backgroundColor: "#fff" }}
                    ref={unitRef}
                    value={location.state.detail.unit_no}
                  />
                </div>
              </div>
            </div>
          }
          <div className={styles.box2}>
            <div
              // className={styles.divide}
              style={{ width: "100%" }}
            >
              <Label label="Description" required={false} />
              <div>
                <textarea
                  // style={{
                  //   marginTop: "1rem",
                  // }}
                  className="form-control"
                  rows={2}
                  placeholder={""}
                  // ref={noteRef}
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                ></textarea>
              </div>
            </div>
          </div>
          <button className={styles.button} onClick={(e: any) => {
            if(userPreference.project_update_approved === false){
              e.preventDefault()
              dispatcher(
                showSnackbarAction(
                  "You are not allowed to edit project. Please contact your admin",
                  "error"
                )
              )
            }
            else{
              edit(e)
            }}}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
    organizationData: state.organization.organizationData,
    authToken:state.user.authToken,
    constants:state.constants.data,
    userPreference:state.userPreference.data,
    organizationResources:state.organizationResources.data
  };
};

export default connect(mapStateToProps)(ProjectEditModal);
